import { FolderService } from '../../../../service/FolderService';
import { UserService } from '../../../../service/UserService';
import { Folder } from '../../../../util/Types/Folder';
import { SpaceOption } from '../types';

interface EnsureReservedFolderOptions {
  onPrivateFoldersUpdated?: (folders: Folder[]) => void;
  onSpacesUpdated?: (spaces: (SpaceOption & { folder?: Folder[] })[]) => void;
}

export const ensureReservedFolder = async (
  folderName: string,
  spaceId: string | undefined,
  options?: EnsureReservedFolderOptions,
): Promise<string | null> => {
  try {
    const response = await FolderService.ensureFolder({
      name: folderName,
      spaceId,
    });
    const folder = response.data;

    if (spaceId) {
      const spacesResponse = await UserService.getSpaces();
      options?.onSpacesUpdated?.(spacesResponse.data);
    } else {
      const foldersResponse = await FolderService.getFolders();
      options?.onPrivateFoldersUpdated?.(foldersResponse.data || []);
    }

    return folder.id;
  } catch (error) {
    console.error(`Failed to ensure folder ${folderName}:`, error);
    return null;
  }
};
